import { ActionType } from 'typesafe-actions'

import { brandsActionType, brandsActions } from './actions'
import { Brand } from './brands'

export interface BrandsState {
  readonly error: Error
  readonly isLoading: boolean
  readonly brands: Brand[]
}

export const initialState: BrandsState = {
  error: null,
  isLoading: false,
  brands: [],
}

export const brandsReducer = (
  state: BrandsState = initialState,
  action: ActionType<typeof brandsActions>
) => {
  switch (action.type) {
    case brandsActionType.FETCH_BRANDS:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case brandsActionType.FETCH_BRANDS_SUCCEEDED:
      return {
        ...state,
        isLoading: false,
        error: null,
        brands: action.payload.brands,
      }
    case brandsActionType.THROW_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      }
    default:
      return state
  }
}